module.exports = __webpack_public_path__ + "static/media/image_10.ee924492.jpg";